export default __webpack_public_path__ + "static/color-tokens-in-screen-light-fc2d68fe748a455967fac6216fd5009fc5536144b40e30df29e9a971bc7cadb4.png";